export default __webpack_public_path__ + "assets/NexwayWhiteLogo.29db7197672a599d88f00a1da91b1b3b.png";